import { t } from '../utils/translations'
import ThemeToggle from './ThemeToggle'

export default function AppBranding({
  lang = 'zh',
  titleTag: TitleTag = 'h1',
  className = '',
  showControls = true,
}) {
  return (
    <div className={`app-branding ${className}`.trim()}>
      <div className="app-branding-text">
        <p className="app-branding-kicker">HKMBC</p>
        <TitleTag className="app-branding-title">{t('appTitle', lang)}</TitleTag>
        <span className="app-branding-subtitle">{t('appSubtitle', lang)}</span>
      </div>
      {showControls ? (
        <div className="app-branding-controls">
          <ThemeToggle />
          <img
            className="app-branding-logo"
            src="/hkmbc-logo.gif"
            alt="HKMBC logo"
            width={44}
            height={44}
          />
        </div>
      ) : null}
    </div>
  )
}
